module.exports = __webpack_public_path__ + "img/shop3-1.aeaa8d66.png";